<template>
    <div class="call-api">
        <div class="pro-num">
            <span>项目总数：</span>
            <span>{{proData.length}}</span>
        </div>
        <div class="pro-content">
            <div class="pro-list" :class="{'active':ifShowDetail}">
                <div @click="showDetail(item)" class="list" v-for="(item,index) in proData" :key='index'>
                    <div class="title" :title='item.name'>{{item.name.length>15?item.name.substring(0,15)+'...':item.name}}</div>
                    <div class="appid">
                        <span>appid：</span>
                        <span>{{item.appId}}</span>
                        <span @click.stop="copyAppid(item.appId)">复制</span>
                        <textarea style="position:fixed;z-index:-10000;left:-1000" id="copyHtml1"></textarea>
                    </div>
                    <div class="appkey">
                        <span>appkey：</span>
                        <span >{{item.appKey}}</span>
                        <span @click.stop="copyAppkey(item.appKey)">复制</span>
                        <textarea style="position:fixed;z-index:-10000;left:-1000" id="copyHtml2"></textarea>
                    </div>
                    <div style="clear:both"></div>
                    <div class="time-set">
                        <span class="work-time">工作时间：</span>
                        <span v-if="item.weekList.length==0" class="unset">未设定</span>
                        <span v-if="item.weekList.length!=0" class="unset">已设定</span>
                        <div v-if="item.weekList.length!=0" class="task1">
                            <div class="task-content">
                                <div class="content-task"></div>
                                <div style="position:absolute;padding:0 12px 12px 0">
                                    <div class="date">
                                        <span v-for="(item1,index1) in item.weekList" :key='index1' style="display:inline-block;margin-right:5px;">{{judgeDay(item1)}}</span>
                                    </div>
                                    <div class="time">
                                        <div>[时间段1] {{item.timeQuantum1.startTime}}-{{item.timeQuantum1.endTime}}</div>
                                        <div class="afternoon">[时间段2] {{item.timeQuantum2.startTime}}-{{item.timeQuantum2.endTime}}</div>
                                        <div class="afternoon">[时间段3] {{item.timeQuantum3.startTime}}-{{item.timeQuantum3.endTime}}</div>
                                        <div class="afternoon">[时间段4] {{item.timeQuantum4.startTime}}-{{item.timeQuantum4.endTime}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="site-set">
                        <span class="callback-site">回调地址：</span>
                        <span v-if="item.callbackUrl==''" class="unset">未设定</span>
                        <span v-if="item.callbackUrl!=''" class="unset">已设定</span>
                        <div v-if="item.callbackUrl!=''" class="task2">
                            <div class="task-content">
                                <div class="content-task"></div>
                                <div style="position:absolute;padding:0 12px 12px 0">
                                    <div class="url">{{item.callbackUrl}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="text-align:center;" v-if="proData.length==0">
                    <img style="width:140px;margin:200px auto;" src="../../assets/img/none.png" alt="">
                </div>
            </div>
            <div v-if="ifShowDetail" class="right-content">
                <div style='border-bottom:1px solid rgba(240, 240, 240, 1);padding-bottom:12px'>
                    <span style="color:rgba(80, 80, 80, 1);font-size:16px;">基本信息高级配置</span>
                    <a-icon @click="hideDetail" style="float:right;cursor:pointer;font-size:18px;" type="close" />
                </div>
                <div style="margin:16px 0;display:flex;">
                    <span style="color:rgba(153, 153, 153, 1);font-size:14px;display:inline-block;width:55px;">appid：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:12px;flex:1;margin-top:2px">{{itemDetail.appId}}</span>
                </div>
                <div style="display:flex;border-bottom:1px solid rgba(240, 240, 240, 1);padding-bottom:16px;margin-bottom:16px">
                    <span style="color:rgba(153, 153, 153, 1);font-size:14px;width:55px;">appkey：</span>
                    <span style="color:rgba(80, 80, 80, 1);font-size:12px;flex:1;word-wrap: break-word;word-break: break-all;margin-top:2px;">{{itemDetail.appKey}}</span>
                </div>
                <div class="working-time-box" style="padding-bottom:16px;border-bottom:1px solid rgba(240, 240, 240, 1);margin-bottom:16px;">
                    <div style="color:rgba(80, 80, 80, 1);font-size:16px;margin-bottom: 14px">项目工作时间设定：</div>
                    <a-checkbox-group v-model="itemDetail.weekList" @change="chooseWorkingTime">
                        <a-row>
                            <a-col :span="6">
                                <a-checkbox value="MONDAY">
                                周一
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="TUESDAY">
                                周二
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="WEDNESDAY">
                                周三
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="THURSDAY">
                                周四
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="FRIDAY">
                                周五
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="SATURDAY">
                                周六
                                </a-checkbox>
                            </a-col>
                            <a-col :span="6">
                                <a-checkbox value="SUNDAY">
                                周日
                                </a-checkbox>
                            </a-col>
                        </a-row>
                    </a-checkbox-group>
                    <div style="margin:16px 0;color:rgba(153, 153, 153, 1);font-size:12px;">
                        <span>时间段1：</span>
                        <a-time-picker style='width:109px;' placeholder='开始时间' v-model="itemDetail.timeQuantum1.startTime" format="HH:mm"/>
                        <span style="margin:0 2px;">~</span>
                        <a-time-picker style='width:109px;' placeholder='结束时间' v-model="itemDetail.timeQuantum1.endTime" format="HH:mm"/>
                    </div>
                    <div style="color:rgba(153, 153, 153, 1);font-size:12px;">
                        <span>时间段2：</span>
                        <a-time-picker style='width:109px;' placeholder='开始时间' v-model="itemDetail.timeQuantum2.startTime" format="HH:mm"/>
                        <span style="margin:0 2px;">~</span>
                        <a-time-picker style='width:109px;' placeholder='结束时间' v-model="itemDetail.timeQuantum2.endTime" format="HH:mm"/>
                    </div>
                    <div style="margin:16px 0;color:rgba(153, 153, 153, 1);font-size:12px;">
                        <span>时间段3：</span>
                        <a-time-picker style='width:109px;' placeholder='开始时间' v-model="itemDetail.timeQuantum3.startTime" format="HH:mm"/>
                        <span style="margin:0 2px;">~</span>
                        <a-time-picker style='width:109px;' placeholder='结束时间' v-model="itemDetail.timeQuantum3.endTime" format="HH:mm"/>
                    </div>
                    <div style="color:rgba(153, 153, 153, 1);font-size:12px;">
                        <span>时间段4：</span>
                        <a-time-picker style='width:109px;' placeholder='开始时间' v-model="itemDetail.timeQuantum4.startTime" format="HH:mm"/>
                        <span style="margin:0 2px;">~</span>
                        <a-time-picker style='width:109px;' placeholder='结束时间' v-model="itemDetail.timeQuantum4.endTime" format="HH:mm"/>
                    </div>
                </div>
                <div>
                    <div style="color:rgba(80, 80, 80, 1);font-size:16px;margin-bottom: 14px">话单回调地址：</div>
                    <a-textarea v-model="itemDetail.callbackUrl" placeholder="请输入链接" style="width:100%;height:75px;"/>
                </div>
                <div class="btn-group">
                    <span @click="hideDetail">取消</span>
                    <span @click="saveProDetail">应用</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
export default {
    name: 'CallApi',
    props: {
        msg: String
    },
    data() {
        return {
            ifShowDetail: false,
            proData: [],
            itemDetail: {
                id: '',
                appId: '',
                appKey: '',
                weekList: [],
                timeQuantum1: {
                    startTime: "",
                    endTime: ""
                },
                timeQuantum2: {
                    startTime: "",
                    endTime: ""
                },
                timeQuantum3: {
                    startTime: "",
                    endTime: ""
                },
                timeQuantum4: {
                    startTime: "",
                    endTime: ""
                },
                callbackUrl: ''
            }
        };
    },
    methods: {
        moment,
        showDetail(item) {
            this.ifShowDetail = true
            this.itemDetail.appId = item.appId?item.appId:''
            this.itemDetail.appKey = item.appKey?item.appKey:''
            this.itemDetail.id = item.id?item.id:''
            this.itemDetail.weekList = item.weekList?item.weekList:[]
            this.itemDetail.timeQuantum1.startTime = item.timeQuantum1.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum1.startTime,"HH:mm")
            this.itemDetail.timeQuantum1.endTime = item.timeQuantum1.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum1.endTime,"HH:mm")
            this.itemDetail.timeQuantum2.startTime = item.timeQuantum2.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum2.startTime,"HH:mm")
            this.itemDetail.timeQuantum2.endTime = item.timeQuantum2.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum2.endTime,"HH:mm")
            this.itemDetail.timeQuantum3.startTime = item.timeQuantum3.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum3.startTime,"HH:mm")
            this.itemDetail.timeQuantum3.endTime = item.timeQuantum3.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum3.endTime,"HH:mm")
            this.itemDetail.timeQuantum4.startTime = item.timeQuantum4.startTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum4.startTime,"HH:mm")
            this.itemDetail.timeQuantum4.endTime = item.timeQuantum4.endTime==""?moment("00:00","HH:mm"):moment(item.timeQuantum4.endTime,"HH:mm")
            this.itemDetail.callbackUrl = item.callbackUrl?item.callbackUrl:''
        },
        hideDetail() {
            this.ifShowDetail = false
        },
        copyAppid(url) {
            let text = url
            let input = document.getElementById("copyHtml1");
            input.value = text; 
            input.select(); 
            document.execCommand("copy"); 
            this.$message.success('复制成功');
        },
        copyAppkey(url) {
            let text = url
            let input = document.getElementById("copyHtml2");
            input.value = text; 
            input.select(); 
            document.execCommand("copy"); 
            this.$message.success('复制成功');
        },
        queryProList() {
            this.axios(
                {
                    method:'get',
                    url:'/api/openApi/project/list', 
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.proData = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        chooseWorkingTime(value) {
            this.itemDetail.weekList = value
        },
        saveProDetail() {
            this.axios.post('/api/openApi/project', {
                id: this.itemDetail.id,
                weekList: this.itemDetail.weekList,
                timeQuantum1: {
                    startTime: moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm'),
                    endTime: moment(this.itemDetail.timeQuantum1.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum1.endTime, 'HH:mm').format('HH:mm'),
                },
                timeQuantum2: {
                    startTime: moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm'),
                    endTime: moment(this.itemDetail.timeQuantum2.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum2.endTime, 'HH:mm').format('HH:mm'),
                },
                timeQuantum3: {
                    startTime: moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm'),
                    endTime: moment(this.itemDetail.timeQuantum3.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum3.endTime, 'HH:mm').format('HH:mm'),
                },
                timeQuantum4: {
                    startTime: moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm'),
                    endTime: moment(this.itemDetail.timeQuantum4.startTime, 'HH:mm').format('HH:mm')=='00:00'&&moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm')=='00:00'?null:moment(this.itemDetail.timeQuantum4.endTime, 'HH:mm').format('HH:mm'),
                },
                callbackUrl: this.itemDetail.callbackUrl
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$message.success('配置成功');
                    this.queryProList()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        judgeDay(day) {
            switch (day) {
                case 'MONDAY':
                    return "周一"
                case 'TUESDAY':
                   return "周二"
                case 'WEDNESDAY':
                    return "周三"
                case 'THURSDAY':
                    return "周四"
                case 'FRIDAY':
                    return "周五"
                case 'SATURDAY':
                    return "周六"
                case 'SUNDAY':
                    return "周日"
            } 
        }
    },
    mounted: function() {
        this.sessionData('set','channelItem','外呼api');
        this.queryProList()
    },
}
</script>
<style scoped  lang="less">
    .call-api{
        padding: 22px 23px;
        height: 100%;
        padding-bottom: 58px;
        .pro-num{
            color: rgba(80, 80, 80, 1);
            font-size: 14px;
            height: 33px;
        }
        .pro-content{
            flex: 1;
            height: 100%;
            overflow-y: auto;
            padding-bottom: 48px;
            .pro-list{
                padding-top: 16px;
                .list{
                    cursor: pointer;
                    width: 305px;
                    height: 194px;
                    background: #fff;
                    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
                    padding: 22px 22px 0 24px;
                    margin-bottom: 20px;
                    margin-right: 20px;
                    display: inline-block;
                    .title{
                        color: rgba(51, 51, 51, 1);
                        font-size: 16px;
                    }
                    .appid{
                        margin-top: 9px;
                        span:nth-child(1){
                            color: rgba(153, 153, 153, 1);
                            font-size: 13px;
                            display: inline-block;
                            width: 60px;
                        }
                        span:nth-child(2){
                            color: rgba(80, 80, 80, 1);
                            font-size: 12px;
                            display: inline-block;
                            width: 170px;
                        }
                        span:nth-child(3){
                            color: rgba(34, 215, 187, 1);
                            font-size: 12px;
                            cursor: pointer;
                            margin-left: 5px;
                        }
                    }
                    .appkey{
                        float: left;
                        margin-top: 9px;
                        span:nth-child(1){
                            color: rgba(153, 153, 153, 1);
                            font-size: 13px;
                            display: inline-block;
                            width: 60px;
                            float: left;
                        }
                        span:nth-child(2){
                            color: rgba(80, 80, 80, 1);
                            font-size: 12px;
                            display: inline-block;
                            width: 170px;
                            word-wrap: break-word;
                            float: left;
                        }
                        span:nth-child(3){
                            color: rgba(34, 215, 187, 1);
                            font-size: 12px;
                            float: left;
                            margin-top: 8px;
                            cursor: pointer;
                            margin-left: 5px;
                        }
                    }
                    .time-set{
                        margin-top: 9px;
                        position: relative;
                        .work-time{
                            color: rgba(153, 153, 153, 1);
                            font-size: 12px;
                            display: inline-block;
                            width: 60px;
                        }
                        .unset{
                            color: rgba(80, 80, 80, 1);
                            font-size: 12px;
                        }
                        .task1{
                            width: 172px;
                            height: 160px;
                            overflow: hidden;
                            border-radius: 4px;
                            position: absolute;
                            left: 100px;
                            top: 5px;
                            color: #fff;
                            font-size: 12px;
                            z-index: 10;
                            display: none;
                            .task-content{
                                width: 100%;
                                height: 100%;
                                position: relative;
                                padding: 12px;
                                .content-task{
                                    width: 100%;
                                    height: 100%;
                                    background: rgba(8, 11, 15, 0.7);
                                    position: absolute;
                                    left: 0;
                                    top: 0;
                                }
                                .date{
                                    border-bottom: 1px solid rgba(153, 153, 153, 1);
                                    padding-bottom: 10px;
                                    z-index: 12;
                                    color: #fff;
                                }
                                .time{
                                    padding-top: 10px;
                                    .afternoon{
                                        margin-top: 5px;
                                    }
                                }
                            }
                        }
                    }
                    .time-set:hover{
                        .task1{
                            display: block;
                        }
                    }
                    .site-set{
                        margin-top: 9px;
                        position: relative;
                        .callback-site{
                            color: rgba(153, 153, 153, 1);
                            font-size: 12px;
                            display: inline-block;
                            width: 60px;
                        }
                        .unset{
                            color: rgba(80, 80, 80, 1);
                            font-size: 12px;
                        }
                        .task2{
                            width: 172px;
                            height: 80px;
                            overflow: hidden;
                            border-radius: 4px;
                            position: absolute;
                            left: 100px;
                            top: 5px;
                            color: #fff;
                            font-size: 12px;
                            z-index: 10;
                            display: none;
                            .task-content{
                                width: 100%;
                                height: 100%;
                                position: relative;
                                padding: 12px;
                                word-wrap: break-word;
                                .content-task{
                                    width: 100%;
                                    height: 100%;
                                    background: rgba(8, 11, 15, 0.7);
                                    position: absolute;
                                    left: 0;
                                    top: 0;
                                }
                                .url{
                                    z-index: 12;
                                    color: #fff;
                                    white-space: break-spaces;
                                    word-break: break-all;
                                }
                            }
                            
                        }
                    }
                    .site-set:hover{
                        .task2{
                            display: block;
                        }
                    }
                }
            }
            .right-content{
                width: 320px;
                position: fixed;
                right: 0px;
                top: 106px;
                height: 100%;
                background: #fff;
                padding: 12px 11px 116px 24px;
                .btn-group{
                    margin-top: 30px;
                    span{
                        width: 80px;
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        cursor: pointer;
                        display: inline-block;
                        margin-right: 16px;
                        font-size: 14px;
                        border-radius: 4px;
                    }
                    span:nth-child(1){
                        color: rgba(34, 215, 187, 1);
                        border: 1px solid rgba(34, 215, 187, 1);
                    }
                    span:nth-child(2){
                        color: #fff;
                        background: rgba(34, 215, 187, 1);
                    }
                }
            }
        }
        .active{
            padding-right: 320px;
        }
    }
</style>
